import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PropTypes from 'prop-types';

// component used to pagination 
export default function TablePagination({
    currentPage,
    totalPages,
    handlePageChange,
    rowsPerPage,
    setRowsPerPage,
    rowsPerPageOptions = [20, 30, 50, 100]
}) {
    return (
        <nav aria-label="..." className="d-flex justify-content-between">
            {/* Filter for row per page */}
            <div
                className="rows-per-page-dropdown"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <label
                    htmlFor="rowsPerPage"
                >
                    Rows per page:
                </label>
                <select
                    id="rowsPerPage"
                    value={rowsPerPage}
                    onChange={(e) => {
                        const newRowsPerPage = parseInt(e.target.value, 10);
                        setRowsPerPage(newRowsPerPage);
                        handlePageChange(1);
                    }}
                    style={{
                        padding: '0.25rem 0.5rem',
                        border: '1px solid #ced4da',
                        borderRadius: '0.25rem',
                        fontSize: '1rem',
                        color: '#495057',
                        backgroundColor: '#fff',
                        backgroundClip: 'padding-box',
                        marginLeft: '5px',
                        marginTop: '-5px'
                    }}
                >
                    {rowsPerPageOptions.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>

            {/* Use to show current page  */}
            <div
                className="page-info"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <p className="mt-2">Page {currentPage} of {totalPages}</p>
            </div>

            {/* Pagination using react strap */}
            <Pagination className="pagination justify-content-end mb-0" listClassName="justify-content-end mb-0">
                {totalPages > 1 ? (
                    <>
                        {/* go to first page button */}
                        <PaginationItem disabled={currentPage === 1}>
                            <PaginationLink
                                first
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handlePageChange(1);
                                }}
                            />
                        </PaginationItem>
                        {/* button for prev page */}
                        <PaginationItem disabled={currentPage === 1}>
                            <PaginationLink
                                previous
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage > 1) handlePageChange(currentPage - 1);
                                }}
                            />
                        </PaginationItem>

                        {/* Current Page button */}
                        <PaginationItem active>
                            <PaginationLink
                                href="#"
                                onClick={(e) => e.preventDefault()}
                            >
                                {currentPage}
                            </PaginationLink>
                        </PaginationItem>

                        {/* go to next page button */}
                        <PaginationItem disabled={currentPage === totalPages}>
                            <PaginationLink
                                next
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage < totalPages) handlePageChange(currentPage + 1);
                                }}
                            />
                        </PaginationItem>
                        {/* Go to last page button */}
                        <PaginationItem disabled={currentPage === totalPages}>
                            <PaginationLink
                                last
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handlePageChange(totalPages);
                                }}
                            />
                        </PaginationItem>
                    </>
                ) : (
                    // use to if only one page avaiable 
                    <PaginationItem active>
                        <PaginationLink href="#" onClick={(e) => e.preventDefault()}>
                            1
                        </PaginationLink>
                    </PaginationItem>
                )}
            </Pagination>
        </nav>
    );
}

TablePagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    setRowsPerPage: PropTypes.func.isRequired,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number)
};
